import { render, staticRenderFns } from "./DeleteBtn.vue?vue&type=template&id=08d52c5e&scoped=true&lang=pug&"
import script from "./DeleteBtn.vue?vue&type=script&lang=js&"
export * from "./DeleteBtn.vue?vue&type=script&lang=js&"
import style0 from "./DeleteBtn.vue?vue&type=style&index=0&id=08d52c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d52c5e",
  null
  
)

export default component.exports